import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import { wsmKitAddPath, wsmKitListPath, wsmKitPath } from "./urls";
import WsmKitCreateView from "./views/WsmKitCreate";
import WsmKitDetailsView from "./views/WsmKitDetails";
import WsmKitListView from "./views/WsmKitList";

const KitDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmKitDetailsView id={decodeURIComponent(match.params.id)} />
);

// The "add" route comes before the :id route, which would otherwise match it.
const Component = () => (
  <>
    <WindowTitle title="Bundles & Kits" />
    <Switch>
      <Route exact path={wsmKitAddPath} component={WsmKitCreateView} />
      <Route exact path={wsmKitListPath} component={WsmKitListView} />
      <Route exact path={wsmKitPath(":id")} component={KitDetails} />
    </Switch>
  </>
);

export default Component;
